import { hash } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { eq, or } from 'ember-truth-helpers';

import LinkToDetail from 'umg-ember-backend/components/ui/link-to-detail';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import DateComponent from './date';
import DefaultComponent from './default';
import LinkComponent from './link';
import RelationComponent from './relation';
import RowActionsComponent from './row-actions';
import RowStatusComponent from './row-status';
import SanitizeHtmlComponent from './sanitize-html';
import styles from './styles.module.css';
import TranslateValueComponent from './translate-value';

const bem = getBem(styles);

export default class RecordExplorerTableRowCell extends Component {
  // Services
  @service intl;
  @service media;

  // Getter and setter
  get valueProperty() {
    return this.args.column.valuePath ?? this.args.column.property;
  }

  get columnComponent() {
    const columnType = this.args.column.type ?? 'default';
    const columns = {
      'date': DateComponent,
      'default': DefaultComponent,
      'link': LinkComponent,
      'relation': RelationComponent,
      'row-actions': RowActionsComponent,
      'row-status': RowStatusComponent,
      'sanitize-html': SanitizeHtmlComponent,
      'translate-value': TranslateValueComponent,
    };

    return columns[columnType];
  }

  get value() {
    if (!this.valueProperty) {
      return null;
    }

    return this.args.record[this.valueProperty];
  }

  // Template
  <template>
    <td
      class={{bem
        (hash
          align=@column.align
          is-truncate=@column.isTruncate
          is-main-column=@column.isMainColumn
          type=@column.type
        )
      }}
      data-test-table-td
      data-test-table-td-align={{@column.align}}
      data-test-table-td-type={{@column.type}}
      data-test-table-td-is-main-column={{@column.isMainColumn}}
      data-test-table-td-is-truncate={{@column.isTruncate}}
      ...attributes
    >
      {{#if
        (or
          @column.isMainColumn @column.isLinkToDetail (eq @column.property 'id')
        )
      }}
        <LinkToDetail @model={{@record}}>
          <this.columnComponent
            @column={{@column}}
            @record={{@record}}
            @recordActions={{@recordActions}}
            @value={{this.value}}
          />
        </LinkToDetail>
      {{else}}
        <this.columnComponent
          @column={{@column}}
          @record={{@record}}
          @recordActions={{@recordActions}}
          @value={{this.value}}
        />
      {{/if}}
    </td>
  </template>
}
